/* eslint-disable */
import pt from 'vuetify/lib/locale/pt';

export default {
  ...pt,
  // NOMES IDIOMAS
  'campo vazio': '',
  idioma: 'Idioma',
  // GERAL
  meusDados: 'Meus dados',
  sair: 'Sair',
  pesquisar: 'Pesquisar',
  kanban: 'Kanban',
  todosClientes: 'Todas as empresas',
  null: 'N/I',
  selecionados: 'Selecionados',
  recusar: 'Recusar',
  aceitar: 'Aceitar',
  // NOVAS ATUALIZAÇÕES
  novasAtualizacoes: 'NOVO!',
  // FILTROS
  pesquisarBy: 'Pesquisar processos pelo código ou referência',
  filtros: 'Filtros',
  download: 'Download',
  periodo: 'Período',
  tipoData: 'Tipo de data:',
  mostrarEncerrados: 'Mostrar processos encerrados',
  encerrado: 'Encerrado',
  fechado: 'Fechado',
  Abertura: 'Abertura',
  ETD: 'ETD',
  ETA: 'ETA',
  etd: 'ETD',
  eta: 'ETA',
  Embarque: 'Embarque',
  Chegada: 'Chegada',
  Originais: 'Originais',
  'Registro DI': 'Registro DI',
  removerFiltros: 'Remover filtros',
  filtrar: 'Filtrar',
  ate: ' até ',
  warningFiltro: 'Selecione um período válido e um tipo de busca.',
  // MENU
  dashboard: 'Dashboard',
  tituloTooltipDashboard: 'Visualize os dados estatísticos sobre \no desempenho dos processos de importação.',
  demandas: 'Demandas',
  abrirProcessos: 'Abrir processos',
  novosProcessos: 'Novos processos',
  tituloTooltipNovosProcessos: 'Inicie um novo processo e aguarde o andamento deste para as estapas de \nimportação. Edite os processos clicando duas vezes em cima do campo desejado.',
  inicieUmNovoProcesso: 'Inicie um novo processo e aguarde o andamento deste para as etapas de importação.',
  followUp: 'Follow-Up',
  inventario: 'Inventário',
  tituloTooltipEstoque:
    'Possui o propósito de manter os níveis ideais de estoque, \nde acordo com os objetivos e demandas da empresa.',
  armazem: 'Armazém',
  financeiro: 'Financeiro',
  relatorios: 'Relatórios',
  relatorio: 'Relatório',
  tituloTooltipRelatorios:
    'Medidas aplicadas pelo governo com o objetivo de oferecer a redução ou a isenção da alíquota dos impostos para a importação de bens.',
  nomeRelatorio: 'Nome Relatório',
  documentos: 'Documentos',
  base: 'Base',
  usuarios: 'Usuários',
  tituloTooltipUsuarios: 'Cadastre usuários para poder compartilhar dados',
  selecione: 'Selecione',
  selecioneTipo: 'Selecione um tipo de usuário',
  selecioneDias: 'Selecione quantos dias desejar',
  claro: 'Claro',
  escuro: 'Escuro',
  direitosReservados: 'Todos os direitos reservados',
  versao: 'Versão',
  termosCondicoes: 'Termos e Condições',
  politicasPrivacidade: 'Políticas de privacidade',
  // ROLES
  ADMINISTRADOR: 'ADMINISTRADOR',
  ANALISTA: 'ANALISTA',
  CLIENTE: 'CLIENTE',
  CLIENTE_GESTOR: 'CLIENTE GESTOR',
  'CLIENTE GESTOR': 'CLIENTE GESTOR',
  CLIENTE_CONSULTOR: 'CLIENTE CONSULTOR',
  'CLIENTE CONSULTOR': 'CLIENTE CONSULTOR',
  // MODAL EXPORTAR EM EXCEL
  tituloModalExportar: 'Exportar em planilha Excel',
  planilhaBaixada: 'Planilha baixada com sucesso',
  descricaoModalExportar: 'Seleciona as colunas que você deseja exibir.',
  disponiveis: 'Disponíveis',
  selecionadas: 'Selecionadas',
  selecionarTodos: 'Selecionar todos',
  removerTodos: 'Remover todos',
  gerarArquivo: 'Salvar arquivo',
  Referência: 'Referência',
  Processo: 'Processo',
  'Status do Embarque': 'Status do Embarque',
  'Unidade de Negócio': 'Unidade de Negócio',
  'Unidade de Medida': 'Unidade de Medida',
  Quantidade: 'Quantidade',
  Exportador: 'Exportador',
  Transportadora: 'Transportadora',
  Produto: 'Produto',
  'Conhecimento de Embarque': 'Conhecimento de Embarque',
  'Número DI': 'Número DI',
  'Canal DI': 'Canal DI',
  Desembaraço: 'Desembaraço',
  Faturamento: 'Faturamento',
  'Nº NF Entrada': 'Nº NF Entrada',
  Containers: 'Containers',
  tituloTooltipContainers:
    'Essencial para garantir o sucesso das operações de transporte marítimo de cargas, \nproporcionando eficiência, segurança e qualidade aos processos de importação.',
  Container: 'Container',
  'Emissão NF Entrada': 'Emissão NF Entrada',
  'Fechamento Operacional': 'Fechamento Operacional',
  'Exec. Carregamento': 'Exec. Carregamento',
  'Licenças de Importação': 'Licenças de Importação',
  'Armador/Agente de carga': 'Armador/Agente de carga',
  // COLUNAS KANBAN
  tituloTooltipKanban: 'Clique no cartão para mais detalhes do seu processo.',
  tooltipPreEmbarque: 'Data da abertura do processo até a data do embarque',
  tooltipTransito: 'Data do embarque até a chegada do navio no porto',
  tooltipDesembaraco: 'Data da chegada da carga no porto até o desembaraço da DI',
  tooltipCarregamento: 'Data do desembaraço da DI até a conclusão do carregamento',
  tooltipFaturamento: 'Data da conclusão do carregamento até o fechamento operacional',
  preEmbarque: 'Pré-Embarque',
  transito: 'Em Trânsito',
  carregamento: 'Carregamento',
  Carregamento: 'Carregamento',
  carregamentoFaturamento: 'Carregamento/Faturamento',
  carrFaturamento: 'Carr./Faturamento',
  solicitacao: 'Solicitação',
  previsaoNaoInformada: 'Prev. emb não informada',
  dataCarregamento: 'Data carr.',
  dataDoFaturamento: 'Data faturamento',
  dataFat: 'Data fat.',
  restam: 'Restam',
  dias: 'dias',
  atrasado: 'Atrasado',
  emDesembaraco: 'Em desembaraço: ',
  emCarregamento: 'Em carregamento: ',
  emFaturamento: 'Em faturamento: ',
  emFechamento: 'Em fechamento: ',
  diaChegada: 'Dia previsto da chegada',
  registro: 'Registro',
  nenhumItemFoi: 'Nenhum item foi',
  encontradoNaEtapa: 'encontrado na etapa',
  deFaturamento: 'de Faturamento',
  deCarregamento: 'de Carregamento',
  deDesembaraco: 'de Desembaraço',
  deTransito: 'de Trânsito',
  deEmbarque: 'de Pré-embarque',
  Fechamento: 'Fechamento',
  'Em Trânsito': 'Em Trânsito',
  'Em trânsito': 'Em Trânsito',
  'Pré-Embarque': 'Pré-Embarque',
  // MODAL PROCESSO
  numeroContrato: 'Número do contrato',
  taxaCambial: 'Taxa Cambial',
  dataPagamento: 'Data pagamento',
  valorReal: 'Valor em real',
  variacaoCambial: 'Variação cambial',
  cambio: 'Câmbio',
  tituloTooltipCambio: 'Acompanhe as modalidades de pagamentos, vencimentos e tipos de negociações.',
  informacoes: 'Informações',
  invoices: 'Invoices',
  contaCorrente: 'Conta corrente',
  maritima: 'Maritima',
  rodoviaria: 'Rodoviário',
  aerea: 'Aérea',
  embarque: 'Embarque',
  informacoesGerais: 'Informações Gerais',
  tipoProcesso: 'Tipo do processo',
  unidadeNegocio: 'Unidade do negócio',
  referenciaInterna: 'Referência interna',
  referenciaTrust: 'Referência Trust',
  referenciaCliente: 'Referência Cliente',
  'Referência Cliente': 'Referência Cliente',
  'Referência Trust': 'Referência Trust',
  cliente: 'Cliente',
  exportador: 'Exportador',
  produto: 'Produto',
  invoice: 'Invoice',
  cidadeEmbarque: 'Cidade de embarque',
  cidadeDestino: 'Cidade de destino',
  'CONTA E ORDEM': 'CONTA E ORDEM',
  'CONTA E ORDEM DE TERCEIROS': 'CONTA E ORDEM',
  'CONTA PRÓPRIA': 'CONTA PRÓPRIA',
  'CONTA PROPRIA': 'CONTA PRÓPRIA',
  'IMPORTAÇÃO POR ENCOMENDA': 'IMPORTAÇÃO POR ENCOMENDA',
  transporteLogistica: 'Transporte e Logística',
  statusEmbarque: 'Status embarque',
  modal: 'Modal',
  tipoCarga: 'Tipo de carga',
  incoterm: 'INCOTERM',
  incoterms: 'Incoterms',
  conhecimento: 'Conhecimento',
  navioVeiculo: 'Navio/Veículo',
  containers: 'Containers',
  container: 'Container',
  containerConsolidado: 'Container consolidado',
  devolucaoContainer: 'Devolução Contêiner',
  pesoBrutoKG: 'Peso Bruto(KG)',
  pesoLiquidoKG: 'Peso Liquido(KG)',
  URFEntrada: 'URF Entrada/Chegada',
  freeTime: 'Free Time',
  freetime: 'Free Time',
  freteCollect: 'Frete collect',
  fretePrepaid: 'Frete prepaid',
  valorTotalFrete: 'Valor total frete',
  moedaFrete: 'Moeda Frete',
  embalagemFrete: 'Embalagem',
  quantidadeEmbalagem: 'Qtd. Embalagem',
  datasPrevistas: 'Datas previstas',
  previsaoEmbarque: 'Prev. embarque',
  previsaoChegada: 'Previsão de chegada',
  datasConfirmadas: 'Datas confirmadas',
  dataEmbarque: 'Data de embarque',
  dataChegada: 'Data de chegada',
  datasLiberacoes: 'Datas e liberações',
  dataLiberacaoSiscarga: 'Data de liberação Siscarga',
  dataLiberacaoMapa: 'Data de liberação mapa',
  liberacaoMinisterioAgricultadoPecuaria: 'Data de liberação MAPA',
  ultimaMovimentacao: 'Última movimentação',
  presencaCarga: 'Presença de carga',
  anuenciaslicencasImportação: 'Anuências Licenças de importação',
  tituloTooltipLI: 'Acompanhe as licenças necessárias para a importação, visando a \nregurlamentação do comércio internacional e proteção da economia nacional.',
  numLi: 'Nº da LI',
  orgaoAnuente: 'Órgão anuente',
  dataRegistro: 'Data de registro',
  dataStatus: 'Data de status',
  dataValidade: 'Data de validade',
  statusLicenca: 'Status da licença',
  'Status L.I': 'Status da licença',
  declaracaoImportacao: 'Declaração de importação',
  numeroRegistro: 'Número do registro',
  dataDesembaraco: 'Data do desembaraço',
  canalParametrizacao: 'Canal de parametrização',
  parametrizacao: 'Parametrização',
  atualizacoes: 'Atualizações',
  ultimaAtualizacao: 'Última atualização',
  dataNaoInformada: 'Data não informada',
  baixarTodos: 'Baixar Todos',
  solicitacaoNumerario: 'Solicitação de numerário',
  descricao: 'Descrição',
  dataSolicitacao: 'Data da solicitação',
  'Data da solicitação': 'Data da solicitação',
  acessar: 'Acessar',
  Acessar: 'Acessar',
  fechamentoProcesso: 'Fechamento de processo',
  visualizar: 'Visualizar',
  Visualizar: 'Visualizar',
  processo: 'Processo',
  data: 'Data',
  formacaoValorAduaneiro: 'Formação do valor aduaneiro',
  valorAduaneiroEstimado: 'Valor aduaneiro estimado',
  composicao: 'Composição',
  moeda: 'Moeda',
  Moeda: 'Moeda',
  valorNegociado: 'Valor negociado',
  valorBRL: 'Valor BRL',
  impostos: 'Impostos',
  despesasNacionalizacao: 'Despesas de nacionalização',
  icmsIpiTransferencia: 'ICMS/IPI Transferência',
  referencia: 'Referência',
  codigoProcesso: 'Código processo',
  'II - IMPOSTO DE IMPORTAÇAO': 'IMPOSTO DE IMPORTAÇAO',
  naoInformado: 'Não informado',
  semAtualizacoes: 'Sem atualizações',
  as: 'ás',
  semDocumentos: 'Sem documentos disponíveis',
  solicitar: 'Solicitar',
  documento: 'Documento',
  dataEmissao: 'Data de emissão',
  numerario: 'Numerário',
  total: 'Total',
  Total: 'Total',
  nenhumaInformacao: 'Nenhuma informação até o momento',
  notasComplementares: 'Notas complementares',
  notasFiscalEletronica: 'Nota fiscal eletrônica',
  valorNota: 'Valor nota fiscal',
  numeroNota: 'Número da nota',
  codigoDocumento: 'Código do documento',
  totalBruto: 'Total bruto',
  totalLiquido: 'Total liquido',
  despesa: 'Despesa',
  valorBruto: 'Valor bruto',
  valorLiquido: 'Valor liquido',
  meioUtilizado: 'Meio de tansporte utilizado',
  lclFcl: 'LCL (Consolidado/Carga solta), FCL (Em container)',
  tipoBL: 'Número do B/L (Conhecimento de embarque)',
  recintoDesembaraco: 'Recinto aduaneiro de desembaraço',
  unidadeReceitaFederal: 'Unidade da receita federal referente ao porto de entrada',
  VERDE: 'VERDE',
  AMARELO: 'AMARELO',
  VERMELHO: 'VERMELHO',
  CINZA: 'CINZA',
  invoicesProcesso: 'Invoices do processo',
  numeroInvoice: 'Número da invoice',
  produtosInvoice: 'Produtos da invoice',
  item: 'Item',
  Item: 'Item',
  fabricante: 'Fabricante',
  Fabricante: 'Fabricante',
  NCM: 'NCM',
  quantidade: 'Quantidade',
  condicaoPagamento: 'Condição de pagamento',
  'Condição de pagamento': 'Condição de pagamento',
  unidadeMedida: 'Unidade de medida',
  'Unidade de medida': 'Unidade de medida',
  valorUnitario: 'Valor Unitário',
  'Valor Unitário': 'Valor Unitário',
  totalCredito: 'Total crédito',
  totalDebito: 'Total débito',
  diferenca: 'Diferença',
  origem: 'Origem',
  Origem: 'Origem',
  evento: 'Evento',
  Evento: 'Evento',
  credito: 'Crédito',
  Crédito: 'Crédito',
  debito: 'Débito',
  Débito: 'Débito',
  vencimento: 'Vencimento',
  Vencimento: 'Vencimento',
  complemento: 'Complemento',
  Complemento: 'Complemento',
  mapa: 'Mapa',
  notaFiscalEntrada: 'Nota fiscal entrada',
  ENCOMENDA: 'ENCOMENDA',
  PROPRIO: 'PRÓPRIO',
  PRÓPRIO: 'PRÓPRIO',
  'ENCOMENDA PADRAO': 'ENCOMENDA PADRÃO',
  'ENCOMENDA PADRÃO': 'ENCOMENDA PADRÃO',
  'ENCOMENDA ESPECIAL': 'ENCOMENDA ESPECIAL',
  'Nº da LI': 'N° da LI',
  'Órgão anuente': 'Órgão anuente',
  'Data de registro': 'Data de registro',
  'Data de status': 'Data de status',
  'Data de validade': 'Data de validade',
  'Status da licença': 'Status da licença',
  'SEM PARAMETRO': 'SEM PARAMETRO',
  // MAPA
  maritimo: 'Marítimo',
  rodoviario: 'Rodoviário',
  todos: 'Todos',
  abrirProcesso: 'Abrir processo',
  abrirProcessoNovaAba: 'Abrir processo em um nova aba',
  embarcacao: 'Embarcação',
  veiculos: 'Veículos',
  veiculo: 'Veículo',
  portos: 'Portos',
  armazemTaglog: 'Armazém TRUST',
  agrupamentos: 'Agrupamentos',
  trajetoPrevisto: 'Trajeto previsto',
  trajetoPercorrido: 'Trajeto percorrido',
  cotacao: 'Cotação',
  dolar: 'Dólar',
  euro: 'Euro',
  especialistaComex: 'Especialista em COMEX',
  email: 'E-mail',
  celularWhatsapp: 'WhatsApp',
  destino: 'Destino',
  navio: 'Navio',
  Navio: 'Navio',
  visualizarProcesso: 'Visualizar processo',
  porto: 'Porto',
  numeroPassagens: 'Número de passagens',
  CNPJ: 'CNPJ',
  localizacao: 'Localização',
  naviosAgrupados: 'Navios agrupados',
  portosAgrupados: 'Portos agrupados',
  clientesAgrupados: 'Clientes agrupados',
  viagensAgrupados: 'Viagens agrupadas',
  CTE: 'CTe nº',
  viagem: 'Viagem',
  atualizadoEm: 'Atualizado em:',
  por: 'por',
  status: 'Status',
  remetente: 'Remetente',
  destinatario: 'Destinatário',
  destinatarios: 'Destinatários',
  informacaodeCarga: 'Informação de carga',
  valorCarga: 'Valor carga',
  valorCargaAverbada: 'Valor carga averbada',
  valorPrestado: 'valorPrestado',
  valorRecebido: 'valorRecebido',
  // MODAL SELECIONAR CLIENTES
  selecionarClientes: 'Selecionar empresas',
  // ABERTURA DE PROCESSO
  aberturaProcesso: 'Abertura de processo',
  solicitarCancelamento: 'Solicitar cancelamento de processo',
  solicitarAlteracao: 'Solicitar alteração',
  alteracoesEncaminhadas: 'Suas alterações foram salvas e serão encaminhadas para os nossos especialistas analisarem',
  jaPossuiAlteracao: 'Este processo já possui uma solicitação de alteração',
  aguardandoAprovaoAlteracao: 'Aguardando aprovação de alteração',
  solicitacaoAlteracaoPendente: 'Você possui uma solicitação de alteração pendente neste processo',
  alteracoesFeitas: 'Alterações feitas pelo cliente',
  aceitarSolicitacaoPendente: 'Aceitar alterações no processo',
  desejaAceitarAsAlteracoes: 'Você deseja aceitar as alterações?',
  casoAceite: 'Se você confirmar, os dados deste processo serão alterados',
  aguardandoCancelamento: 'Aguardando cancelamento do processo',
  seVoceConfirmar: 'Se você confirmar essa solicitação, ela irá sobrescrever a solicitação atualmente em espera',
  emCancelamento: 'Em cancelamento',
  processoAtualizado: 'Sua solicitação de processo foi atualizada',
  suaSolicitacaoDeCancelamento:
    'Sua solicitação de cancelamento foi encaminhada para nossos especialistas',
  exibirColunas: 'Exibir colunas',
  'Tipo Importação': 'Tipo Importação',
  Finalidade: 'Finalidade',
  modelosProntos: 'Modelos prontos',
  Empresa: 'Empresa',
  'Solicitado em': 'Solicitado em',
  solicitadoPor: 'Solicitado por',
  responsavel: 'Responsável',
  Ações: 'Ações',
  responsaveisNaoVinculados: 'Não há responsáveis vinculados a sua empresa',
  registrosPorPagina: 'Registros por página',
  registros: 'Registros',
  resultados: 'Resultados',
  editar: 'Editar',
  remover: 'Remover',
  solicitarAbertura: 'Solicitar abertura de processo',
  itens: 'Itens',
  Itens: 'Itens',
  observacao: 'Observação',
  anexarArquivos: 'Anexar arquivos',
  arquivosAnexados: 'Arquivos anexados',
  adicionarArquivos: 'Adicionar arquivo',
  salvar: 'Salvar',
  tipoDocumento: 'Tipo de documento',
  escolherArquivo: 'Escolher arquivo',
  unidadeComercializada: 'Un. de medida comercializada',
  carregando: 'Carregando',
  tooltipMercosul:
    'Nomenclatura comum do Mercosul (código que auxilia na identificação dos produtos que circulam no Brasil, Argentina, Paraguai, Uruguai e demais países do Mercosul)',
  modificar: 'Modificar',
  cadastrarProduto: 'Cadastrar produto',
  editarProduto: 'Editar produto',
  adicionarProduto: 'Adicionar produto',
  adicionadoProduto: 'Produto adicionado',
  produtoAdicionado: 'Produto adicionado! Cadastrar Produto?',
  indice: 'Índice',
  todosCamposObrigatorios: 'Todos os campos são obrigatórios',
  preenchaCamposObrigatorios: 'Por favor preencha todos os campos obrigatórios',
  confirmarRemoverLista: 'Voce tem certeza de que quer remover este produto da lista?',
  cadastroFuturo: 'Você pode cadastrá-lo de novo futuramente.',
  editarReferencia: 'Editar referência',
  codigoCliente: 'Código Cliente',
  grupo: 'Grupo',
  fornecedor: 'Fornecedor',
  produtor: 'Produtor',
  produtorFabricante: 'Produtor / Fabricante',
  Fornecedor: 'Fornecedor',
  Produtor: 'Produtor',
  codigoTrust: 'Código Trust',
  textoNCM:
    'Ao cadastrar, você conseguirá utilizar este mesmo produto em outras operações, quando digitar o NCM.',
  cadastrar: 'Cadastrar',
  Importador: 'Importador',
  // LISTAGEM DE PROCESSOS
  listagemProcessos: 'Listagem de processos',
  processosAfiliados: 'Follow-Up Afiliados',
  tituloTooltipListagemProcessos: 'Todos os processos em lista, podendo filtrar \ne salvar em modelos para facilitar o uso.',
  relatorioSalvo: 'Relatório salvo com sucesso',
  relatorioAtualizado: 'Relatório atualizado com sucesso',
  relatorioSemDescricao: 'O relatório não pode ser salvo sem uma descrição',
  modeloRelatorios: 'Modelos de relatórios',
  criarModeloRelatorio: 'Criar um novo modelo de relatório',
  alterarModeloRelatorio: 'Atualizar modelo de relatório',
  digiteAqui: 'Digite aqui',
  digiteAquiNCM: 'Busque aqui por NCM',
  selecioneColunas: 'Selecione as colunas que você deseja exibir',
  criarRelatorio: 'Criar relatório',
  atualizarRelatorio: 'Atualizar relatório',
  relatorioAplicado: 'Relatório aplicado',
  listagem: 'Lista',
  deferimentoLi: 'Deferimento LI',
  // INVENTARIO
  de: 'de',
  fraseEstoqueMiniRefpart1: 'O valor de referência é o estoque atual. Isso significa que se o checkbox for marcado o estoque minimo sera',
  fraseEstoqueMiniRefpart2: '% estoque atual disponível',
  estoqueMinimoMensagemPorcentagemAviso: 'Ao selecionar estoque por porcentagem deve ser entre 1 e 200',
  valorPorPercentagemEstoque: 'Estoque minimo por porcentagem (%) do atual',
  'Código do produto': 'Código do produto',
  'Nome do Produto': 'Nome do Produto',
  'Categoria do NCM': 'Categoria do NCM',
  'Previsão no armazém': 'Previsão no armazém',
  estabelecimento: 'Estabelecimento',
  descricaoGrupo: 'Descrição grupo',
  quantidadeAtual: 'Quantidade atual',
  situacao: 'Situação',
  descricaoEndereco: 'Descrição endereço',
  inventarioDescricao: 'Estoque referente ao dia anterior',
  descricaoProduto: 'Descrição produto',
  depositante: 'Depositante',
  tipoUnidade: 'Tipo de unidade',
  Dias: 'Dias',
  classe: 'Classe',
  quantidadeEmpenhado: 'Quantidade Empenhado',
  quantidadeReserva: 'Quantidade de Reserva',
  armazenadoEm: 'Armazenado em',
  quantidadeProdutosEmTransito: 'Quantidade de produtos em trânsito',
  quantidadeProdutosAtual: 'Quantidade de produtos atuais',
  // ARMAZEM
  // RELATORIOS
  adicionar: 'Adicionar',
  Habilitado: 'Habilitado',
  Descrição: 'Descrição',
  desabilitado: 'Desabilitado',
  'Dias da Semana': 'Dias da semana',
  Horário: 'Horário',
  horarioEnvio: 'Horário de envio',
  'E-mails': 'E-mails',
  editarRelatorio: 'Editar relatório',
  adicionarRelatorio: 'Criar relatório',
  conteudoRelatorio: 'Conteúdo do relatório',
  escolhaColunasFiltros: 'Escolha as colunas ou selecione um filtro favoritado',
  escolhaColunasFiltrosIntro1: 'Você pode favoritar um filtro com as opções de colunas que você preferir.',
  escolhaColunasFiltrosIntro2: 'Essa funcionalidade também está disponível na listagem de processos, podendo filtrar por lá a visualização de processos conforme sua necessidade.',

  habilitarAgendamento: 'Habilitar agendamento',
  cancelar: 'Cancelar',
  naoCancelar: 'Não cancelar',
  excluirAgendamento: 'Excluir agendamento de relatório?',
  naoRecuperavel: 'Uma vez excluído, não é possível recuperar',
  excluirAberturaProcesso: 'Você deseja solicitar o cancelamento do processo?',
  nossosEspecialistasVao:
    'Nossos especialistas vão receber sua solicitação e lhe retornaremos por e-mail com os ajustes',
  recuperavel: 'É possível recuperar após a exclusão.',
  excluido: 'Excluído com sucesso',
  voltarAgendamentos: 'Vamos retornar à listagem de agendamentos',
  tenteNovamente: 'Por favor, tente novamente',
  confirmar: 'Confirmar',
  'Un. de Negócio': 'Un. de Negócio',
  'Un. de Medida': 'Un. de Medida',
  // INCENTIVO FISCAL
  incentivoFiscal: 'Incentivo Fiscal',
  icmsPago: 'ICMS Pago',
  aliquotaIcmsPago: 'Alíquota ICMS pago',
  formaDesconto: 'Forma desconto',
  descontoIcmsPago: 'Desconto ICMS pago',
  pctCliente: '% BC Cliente',
  pctGanhoLiquido: '% Ganho Líquido',
  valorCliente: 'Valor Cliente',
  porcentagemCliente: '% Cliente',
  pctEmpresa: '% Empresa',
  // GED
  ged: 'Gerenciamento eletrônico de documentos',
  tituloTooltipGed: 'Documentos referentes aos últimos 90 dias, para documentos mais antigos, alterar o filtro.',
  baixarSelecionados: 'Baixar selecionados',
  visualizarSelecionados: 'Visualizar Selecionados',
  Documento: 'Documento',
  Tipo: 'Tipo',
  Extensão: 'Extensão',
  arquivoNaoSuportado: 'O arquivo deve ter a extensão xlsx, xls ou csv',
  Data: 'Data',
  // USUARIOS,
  Foto: 'Foto',
  Código: 'Código',
  'Criado em': 'Criado em',
  'Nome completo': 'Nome completo',
  Email: 'E-mail',
  senha: 'Senha',
  confirmarSenha: 'Confirmar senha',
  criarSenha: 'Criar senha',
  caracteresSenha: 'De 8 à 25 caracteres',
  maiusculas: 'Pelo menos uma letra maiúscula e uma minúscula',
  letrasNumeros: 'Letras e números',
  caractereEspecial: "Caractere especial ! @ # $ % & * ' _ + = [ ] { } | : . ? ~ ( ) ; ,",
  adicionarUsuario: 'Adicionar usuário',
  editarUsuario: 'Editar usuário',
  CNPJContatos: 'CNPJs e contatos responsáveis',
  notificacoes: 'Notificações',
  fotoPerfil: 'Foto de perfil',
  opcional: 'Opcional',
  empresas: 'Empresas',
  empresa: 'Empresa',
  tituloTooltipEmpresas: 'Visualize o DNA e os responsáveis das empresas cadastradas',
  nomeEmpresa: 'Nome empresa',
  tipoUsuario: 'Tipo de usuário',
  responsavelComercial: 'Responsável comercial',
  nome: 'Nome',
  responsavelOperacional: 'Responsável operacional',
  clientesCNPJ: 'CNPJ Vinculados',
  consultarCNPJ: 'Vincular outros CNPJs',
  'Cód. Conexos': 'Cod. Conexos',
  Nome: 'Nome',
  Cidade: 'Cidade',
  UF: 'UF',
  'Razão Social': 'Razão Social',
  adicionarSelecionados: 'Adicionar selecionados',
  receberNotificacoes: 'Receber notificações',
  notificacoesWhatsapp: 'Notificações no WhatsApp',
  tipoNotificacao: 'Tipo de notificação',
  // DASHBOARD
  bemVindo: 'Bem-vindo',
  tempoLiberacao: 'Tempo de liberação (dias)',
  tempoLiberacaoProduto: 'Tempo de liberação por produto (dias)',
  top10Produtos: 'Top 10 produtos',
  acertoNumerario: 'Acerto de numerário (%)',
  tempoMedioFechamento: 'Tempo médio de fechamento (dias)',
  processos: 'Processos',
  processoAberto: 'Seu processo foi aberto com sucesso.',
  statusProcesso: 'Status do processo (%)',
  faturamento: 'Faturamento',
  emTempo: 'Em tempo',
  verde: 'Verde',
  vermelho: 'Vermelho',
  amarelo: 'Amarelo',
  cinza: 'Cinza',
  Janeiro: 'Janeiro',
  Fevereiro: 'Fevereiro',
  Março: 'Março',
  Abril: 'Abril',
  Maio: 'Maio',
  Junho: 'Junho',
  Julho: 'Julho',
  Agosto: 'Agosto',
  Setembro: 'Setembro',
  Outubro: 'Outubro',
  Novembro: 'Novembro',
  Dezembro: 'Dezembro',
  janeiro: 'Janeiro',
  fevereiro: 'Fevereiro',
  marco: 'Março',
  abril: 'Abril',
  maio: 'Maio',
  junho: 'Junho',
  julho: 'Julho',
  agosto: 'Agosto',
  setembro: 'Setembro',
  outubro: 'Outubro',
  novembro: 'Novembro',
  dezembro: 'Dezembro',
  // Financeiro
  modalidade: 'Modalidade',
  porcentagem: 'Porcentagem',
  tipoVencimento: 'Tipo vencimento',
  dataVencimento: 'Data de vencimento',
  valor: 'Valor',
  undefined: 'Objeto não encontrado',
  // Mensageiro
  mensageiro: 'Mensageiro',
  tituloTooltipMensageiro:
    'Agende o envio de relatórios para o e-mail sobre seus processo \ne fique por dentro das atualizaçôes que ocorrem.',
  Responsável: 'Responsável',
  'Última execução': 'Última vez executado',
  excluirAgendamentoPadrao: 'Excluir agendamento?',
  excluirProduto: 'Excluir produto?',
  enviarEmail: 'Enviar e-mail agora',
  agendamento: 'Agendamento',
  editarAgendamento: 'Editar agendamento',
  agendar: 'Agendar',
  erroSalvarAgendamentoMensageiro: 'Ocorreu um erro ao salvar o agendamento!',
  agendamentoSalvoComSucesso: 'Agendamento salvo com sucesso',
  redirecionamentoTelaListagem: 'Você será redirecionado para tela de listagem.',
  preenchaTodoAgendamento: 'Por favor preencha todos os campos para realizar o agendamento.',
  preenchaHorarios: 'Por favor, selecione ao menos um horário para agendamento',
  preenchaEmails: 'Por favor, digite ao menos um e-mail válido',
  preenchaDescricao: 'Por favor, preencha o campo de descrição',
  preenchaDias: 'Por favor, selecione ao menos um dia da semana para o agendamento',
  preenchaEmailInvalido: 'Email(s) inválido(s)',
  preenchaEmpresas: 'Por favor, selecione ao menos uma empresa para o agendamento',
  Copiar: 'Copiar',
  Reenviar: 'Reenviar',
  enviar: 'Enviar',
  enviarEmailAgora: 'Deseja realmente enviar o e-mail agora?',
  sucessoEnvioEmail: 'E-mail enviado com sucesso!',
  processoCompartilhadoSucesso: 'Os processos foram compartilhados com sucesso!',
  adiantado: 'Adiantado',
  obrigatorio: 'Atenção: Campo obrigatório.',
  emailInvalido:
    'O endereço de email digitado parece estar incorreto. Por favor, verifique e tente novamente',
  cnpjInvalido: 'Atenção: CNPJ Inválido.',
  senhaInvalida: 'Atenção: Senha não cumpre os requisitos',
  senhasDiferentes: 'Atenção: As senhas não conincidem',

  // notificacoes
  chegada: 'Chegada',
  ativarNotificacoes: 'Selecionar todas as notificações',
  embarquePrevisto: 'Embarque previsto',
  embarqueEfetivo: 'Embarque efetivo',
  manifestoCarga: 'Manifesto de carga',
  emailDestino: 'E-mails de destino',
  empresaSelecionadaNaoExiste: 'A empresa selecionada não está cadastrada',
  cadastroEmpresa: 'Cadastro de empresa',
  cadastroUsuario: 'Cadastro de usuário',
  emailEnviado: 'E-Mail enviado com sucesso',
  vincularEmpresa: 'Vincular empresas',
  frequencia: 'Frequência',
  campos: 'Campos',
  transitTime: 'Tempo de trânsito',
  tituloTooltipTransitTime:
    'Visualize o avanço dos proecesso entre \nas etapas e o tempo previsto para serem concluídos.',
  ano: 'Ano',
  dom: 'Dom',
  seg: 'Seg',
  ter: 'Ter',
  qua: 'Qua',
  qui: 'Qui',
  sex: 'Sex',
  sab: 'Sab',
  DI: 'DI',
  siscarga: 'Siscarga',

  // Tour
  tourCancelar: 'Cancelar',
  tourVoltar: 'Voltar',
  tourProximo: 'Próximo',
  tourFinalizar: 'Finalizar',

  tourBemVindo: 'Boas-Vindas!',
  tourBemVindoMensagem: 'Conheça nossas principais funções. É rapidinho!',

  tourMeusDados: 'Meus Dados',
  tourMeusDadosMensagem: 'Escolha uma foto sua, redefina a sua senha e vincule empresas.',

  tourMapa: 'Mapa',
  tourMapaMensagem: 'Visualize o rastreio de cargas marítimas, rodoviárias e também os portos, armazéns e fabricantes.',

  tourAbrirProcesso: 'Abrir Processo',
  tourAbrirProcessoMensagem: 'Cadastre seus processos aqui e não perca uma atualização.',

  tourFollowUp: 'Follow-Up',
  tourFollowUpMensagem: 'Acompanhe cada etapa da sua importação através do kanban ou da listagem.',

  tourDashboard: 'Dashboard',
  tourDashboardMensagem: 'Consulte os gráficos e estatísticas de seus processos, produtos, numerário entre outras informações.',

  tourDocumentos: 'Documentos',
  tourDocumentosMensagem: 'Verifique os documentos de cada processo e a situação das Licenças de importação.',

  tourTransporte: 'Transporte',
  tourTransporteMensagem: 'Saiba tudo sobre os seus containers, fretes e a performance das entregas.',

  tourArmazenagem: 'Armazenagem',
  tourArmazenagemMensagem: 'Observe a situação de suas mercadorias e ative alarmes para estar sempre abastecido.',

  tourFinanceiro: 'Financeiro',
  tourFinanceiroMensagem: 'Esteja informado sobre o câmbio, incentivo fiscal e custo do armazém.',

  tourCadastros: 'Cadastros',
  tourCadastrosMensagem: 'Adicione usuários, produtos e muito mais, personalizando conforme suas necessidades.',

  tourAtualizacoes: 'Atualizações',
  tourAtualizacoesMensagem: 'Não perca as atualizações dos seus processos e configure o envio para o e-mail.',

  tourObrigado: 'Obrigado pela atenção',
  tourObrigadoMensagem: 'Se ficar com dúvidas, vá na aba Ajuda do seu perfil no menu superior.',

  removerDemanda: 'Você deseja remover esta demanda?',
  possivelRecuperar: 'É possível recuperar após a exclusão',
  proximo: 'Próximo',
  disponivelNCM:
    'O item ficará cadastrado em nosso banco de dados e você conseguirá reutilizar este item em operações futuras.',
  fechar: 'Fechar',
  preenchaTudo: 'Preencha todos os campos antes de cadastrar um item.',
  produtoSalvo: 'Produto cadastrado com sucesso!',
  produtoJaCadastrado: 'Produto já esta cadastrado',
  produtoDeletado: 'Produto deletado com sucesso!',
  ncmAutomatico:
    'Digite o código da NCM, se o mesmo estiver no nosso banco de dados, as informações serão preenchidas automaticamente, parcial ou totalmente.',
  configuracoes: 'Configurações',
  statusAlterado: 'Status alterado',
  hoje: 'Hoje',
  ontem: 'Ontem',
  estaSemana: 'Esta semana',
  semanaPassada: 'Semana passada',
  esteMes: 'Este mês',
  anteriores: 'Anteriores',
  assimQueAtualizar: 'Assim que atualizar',
  diariamente: 'Diariamente',
  semanalmente: 'Semanalmente',
  desabilitarEnvio: 'Desabilitar envio',
  dataRegistroDI: 'Registro DI',
  dataRegistroDi: 'Registro DI',
  numeroProtocoloDI: 'Número protocolo DI',
  dataDesembaracoDI: 'Desembaraço DI',
  dataAbertura: 'Abertura',
  dataFechamentoOperacional: 'Fechamento Operacional',
  dataExecucaoCarregamento: 'Execução do Carregamento',
  carregamentoAgendado: 'Carregamento Agendado',
  dataFaturamento: 'Faturamento',
  dataEnvioFaturamento: 'Envio faturamento',
  emissaoNotaEntrada: 'Emissão nota de entrada',
  dataPresencaCarga: 'Presença de carga',
  conhecimentoEmbarque: 'Conhecimento de embarque',
  numeroConhecimentoEmbarque: 'Nº Conhecimento de embarque',
  dataVistoriaMapa: 'Vistoria do Mapa',
  dataRecebimentoOriginais: 'Recebimento dos Originais',
  cadastrarUsuario: 'Cadastrar usuário',
  listarUsuario: 'Lista de usuários',
  legenda: 'Legenda',
  refazerTour: 'Refazer tour de ajuda',
  sairConta: 'Tem certeza que deseja sair?',
  zoomIn: 'Mais zoom',
  zoomOut: 'Reduzir zoom',
  centralizarMapa: 'Centralizar',
  registroNaoEncontrado: 'Registro não encontrado',
  processoNaoPossuiLocalizacaoMapa: 'O processo não possui localização geográfica registrada',
  avisoCamposObrigatorios: 'Campos marcados com * devem ser preenchidos obrigatoriamente.',
  maisDetalhes: 'Mais detalhes',
  codigoProduto: 'Código produto',
  lote: 'Lote',
  loteFabricacao: 'Lote fabricação',
  dataFabricacao: 'Data de fabricação',
  codigoPallet: 'Código do Pallet',
  codigoSequenciaLote: 'Sequência Lote',
  dataMovimentacao: 'Data de Movimentação',
  numeroLote: 'Número do Lote',
  numeroLoteFabricacao: 'Número do Lote Fabricação',
  quantidadeBloqueada: 'Quantidade bloqueada',
  quantidadeEmpenhada: 'Quantidade Empenhanda',
  carregarTemplate: 'Carregar template',
  importarModelo: 'Importar dados do modelo',
  baixarModelo: 'Baixar modelo',
  solteArquivos: 'Arraste e solte seus arquivos aqui.',
  arquivosPermitidos: 'Arquivos permitidos: XLSX, DOC e PDF.',
  solteCarregar: 'Solte os arquivos aqui para carregar.',
  carregandoArquivos: 'Carregando arquivos...',
  verifiqueAntesSalvar: 'Verifique os campos antes de salvar.',
  processoExiste: 'Este número de referência já existe, verifique.',
  valorTotal: 'Valor total',
  ncm: 'Código NCM',
  descricaoDetalhada: 'Descrição detalhada',
  produtos: 'Produtos',
  tituloTooltipProdutos: 'Cadastre itens para importá-los em seus \nprocessos e tenha o histórico de tudo.',
  // Mensagens de Validacoes cadastro de Produto
  valorUnitarioPositivo: 'O valor unitário deve ser maior que zero',
  quantidadePositivo: 'O campo quantidade deve ser maior que zero',
  preenchaCampoProdutor: 'O campo fabricante está vazio, por favor preencha',
  preenchaCampoFornecedor: 'O campo fornecedor está vazio, por favor preencha',
  preenchaCampoCodigoCliente: 'O campo código de cliente está vazio, por favor preencha',
  preenchaCampoProduto: 'O campo produto está vazio, por favor preencha',
  preenchaCampoUnidadeMedida: 'O campo unidade de medida está vazio, por favor preencha',
  preenchaCampoNCM: 'O campo de código do NCM está vazio, por favor preencha',
  preenchaCampoMoeda: 'O campo moeda está vazio, por favor selecione uma das moedas',
  preenchaCampoEmpresa: 'O campo empresa está vazio, por favor selecione uma das empresas',
  maximo10characteres: 'O campo deve conter no máximo 10 characteres',
  maximo20characteres: 'O campo deve conter no máximo 20 characteres',
  maximo100characteres: 'O campo deve conter no máximo 100 characteres',
  excluirUsuario: 'Excluir usuário',
  //////////////////////////////// ERROS
  ERRO_INTERNO_SERVIDOR_LOGIN:
    'Lamentamos, mas ocorreu um erro interno em nosso servidor ao tentar fazer login. Estamos trabalhando para corrigir o problema e pedimos desculpas pelo inconveniente. Tente novamente em alguns minutos ou entre em contato com o suporte. Obrigado pela compreensão.',
  actions: 'Ações',
  acoes: 'Ações',
  //TAREFAS
  pendente: 'Pendentes',
  administrativo: 'Administrativo',
  aguardando: 'Aguardando',
  regulatorio: 'Regulatório',
  novoProduto: 'Novo produto',
  cadastroNovoProduto: 'Novo produto',
  regulatorioCadastroNovoProduto: 'Novo produto / regulatório',
  REGULATORIOCADASTRONOVOPRODUTO: 'Novo produto / regulatório',
  cadastros: 'Cadastros',
  cancelamentos: 'Cancelamentos',
  acompanhamento: 'Acompanhamento',
  liberacao: 'Liberação',
  nacionalizacao: 'Nacionalização',
  gestaoTarefas: 'Gestão de tarefas',
  id: 'ID',
  licenciamento: 'Licenciamento',
  validacaoRegulatorio: 'Validação do regulatório',
  historico: 'Histórico',
  processoMovido: 'Processo movido para',
  comentar: 'Comentar',
  reenviarAcesso: 'Você deseja enviar um email com um novo acesso? A senha atual será alterada.',
  tarefas: 'Tarefas',
  tarefasProcessoPendente: 'Processo pendente',
  tarefasTratamentoAdministrativo: 'Tratamento Administrativo',
  tarefaRegulatorioCadastroNovoProduto: 'Novo produto / regulatório',
  tarefasAcompanhamento: 'Acompanhamento de pós-embarque',
  tarefasLiberacao: 'Liberação',
  tarefasNacionalizacao: 'Nacionalização',
  tarefasFechamento: 'Fechamento',
  cardJaEstaEmAnaliseProduto: 'Este card já foi criado na etapa de Novo produto / Regulatório',
  cardDuplicadoMensagemVerificacao: 'O processo foi duplicado para permitir atividades simultâneas. Por favor, revise as etapas relacionadas ao Novo Produto e/ou Acompanhamento.',
  atividades: 'Atividades',
  atribuirMim: 'Atribuir a mim',
  proximaEtapa: 'Proxima etapa',
  sim: 'Sim',
  nao: 'Não',
  conferido: 'Conferido',
  filtrosFavoritos: 'Filtros favoritos',
  vincularFiltroModelo: 'Você deseja vincular a última pesquisa/filtro a este modelo?',
  salvarUmFiltro: 'Salvar um filtro',
  criarUmNovoFiltro: 'Criar um filtro favorito',
  editarFiltro: 'Editar filtro',
  filtroSalvo: 'Filtro salvo com sucesso',
  filtroAtualizado: 'Filtro atualizado',
  fltroAplicado: 'Filtro aplicado',
  envioDocumentosFechamento: 'Envio de documentos',
  envioDocumentosFechamentoFisicos: 'Envio de documentos fisicos',
  editarObservacao: 'Editar observação',
  regulatoriocadastronovoproduto: 'regulatório e cadastro novo produto',
  confirmarNovoProduto: 'Confirmar novo produto',
  concluidos: 'Concluidos',
  esconderColunaConcluidos: 'Esconder coluna de concluidos',
  exibirColunaConcluidos: 'Exibir coluna de concluidos',
  // Tarefas atividades administrativo
  aberturaProcessoConexos: 'Abertura de processo no conexos',
  aberturaPastaNuvem: 'Abertura de pasta na nuvem',
  responderEmailAbertura: 'Responder e-mail de abertura',
  tratamentoTributario: 'Tratamento tributário / Classificação Fiscal NCM / Administrativo',
  instrucaoDespacho: 'Instrução de despacho - ID',
  verificacaoCadastroProduto: 'Verificação de cadastro do produto / Fornecedores',
  lancamentoCadastroInvoice: 'Lançamento / Cadastro de Invoice no Conexos',
  conferenciaDocumental: 'Conferência documental',
  solicitacaoFreetime: 'Solicitação de Free-time',
  simulacaoCliente: 'Enviar simulação do cliente',
  emissaoLiPreEmbarque: 'Emissão do LI Pré-embarque',
  cotacaoFreteInternacional: 'Cotação Frete Internacional',
  fechamentoCambio: 'Fechamento de câmbio',
  provisionamentoCambio: 'Provisionamento de câmbio',
  acompanhamentoDeferimentoLiPosEmbarque: 'Deferimento LI pós-embarque',
  emitirLi: 'Emitir LI',
  liPre: 'LI pré',
  liPos: 'LI pós',
  semLi: 'Sem LI',
  solicitadoNF: 'Solicitado NF',
  checklistNotaRealizado: 'Checklist nota realizado',
  solicitacaoEmissaoEnviadoFaturamento: 'Solicitação de emissão enviado o fatuamento',
  digitarLI: 'Digitar LI',
  // Tarefas atividades novoProduto
  recebimentoDescricao: 'Recebimento de descrição / NCM / Dados do fornecedor',
  formularioCadastroProduto: 'Formulário para cadastro de produto',
  formularioCadastroFornecedores: 'Formulário para cadastro de fornecedores',
  aberturaChamadoCadastro: 'Abertura de chamado de cadastro',
  produtoCadastrado: 'Produto cadastrado',
  liberadoImportacao: 'Liberado importação',
  armazenagem: 'Armazenagem',
  transporte: 'Transporte',
  // Tarefas atividade regulatório
  envioFormularioRegulatorio: 'Envio de formulário para o Regulatório',
  envioDocumentos: 'Envio de documentos / MSDS / FISPIQ',
  pendenciaDocumental: 'Pendência documental / informações',
  analiseRegulatorioLiberado: 'Análise Regulatório Liberado',
  // Tarefas atividade acompanhamento
  cadastroConhecimentoConexos: 'Cadastro de conhecimento de embarque no conexos',
  documentosOriginais: 'Documento originais',
  recebimentoDocumentosOriginais: 'Recebimento de documento originais',
  telex: 'Telex',
  conferenciaCeMercante: 'Conferência CE Mercante',
  envioNumerario: 'Envio numerário',
  digitacaoDI: 'Digitação de DI',
  lancamentoMapaMadeira: 'Lançamento Mapa Madeira',
  verificacaoValorConta: 'Verificação de valor em conta',
  autorizacaoRegistroDI: 'Autorização de registro DI / AFRMM',
  provisionamentoNumerarioEncomendaPadrao: 'Provisionamento numerário encomenda padrão',
  liberacaoSiscargaBL: 'Liberação Siscarga/BL',
  envioParaAnuencia: 'Envio para anuência',
  blRetirado: 'B/L Retirado',
  solicitacaoRemocaoDTA: 'Solicitação de remoção DTA',
  solicitacaoRemocaoDTC: 'Solicitação de remoção DTC',
  // Tarefas atividades nacionalizacao
  envioDiRegistrada: 'Envio de DI registrada',
  envioCI: 'Envio da CI',
  liberacaoBL: 'Liberação de BL',
  desbloqueioSiscarga: 'Desbloqueio do Siscarga',
  solicitarExoneracaoICMS: 'Solicitar exoneração ICMS',
  montarNF: 'Montar NF / Conferir despesas para NF',
  liberacaoComex: 'Liberação comex',
  recebimentoNfTrust: 'Recebimento NF Trust',
  programacaoCarregamento: 'Programação de carregamento cliente e transporte',
  liberacaoFaturamentoTerminal: 'Liberação de faturamento do terminal',
  agendamentoRetirada: 'Agendamento de retirada',
  minutaDevolucaoCNTR: 'Minuta devolução CNTR',
  lavacaoAvaria: 'Lavação / Avaria',
  aguardandoRIC: 'Aguardando RIC',
  envioFechamento: 'Envio para fechamento',
  exoneradoAguardando: 'Aguardando exoneração ou Exonerado',
  icmsExonerado: 'ICMS exonerado',
  ricPendente: 'RIC pendente',
  ricRecebida: 'RIC recebida',
  cobrarRIC: 'Cobrar RIC',
  numerarioComplementar: 'Numerário complementar',
  recebimentoNumerarioComplementar: 'Recebimento numerário complementar',
  recebimentoNF: 'Recebimento NF',
  mapaLiberado: 'Mapa liberado',
  liberarMapa: 'Liberar Mapa',
  // Tarefas atividades fechamento
  acompanharProcesso: 'Acompanhar fechamento processo',
  // USUARIOS
  usuarioRemovido: 'Usuário excluído com sucesso',
  acessoEnviado: 'O acesso foi enviado para o email do usuário',
  excluirProprioUsuario: 'Você não pode excluir seu próprio usuário!',
  naoPodeReenviar: 'Você não pode reenviar o próprio email e primeiro acesso!',
  usuarioAtualizado: 'Usuário atualizado com sucesso!',
  usuarioInserido:
    'Usuário inserido com sucesso! Aguarde a senha ser gerada e enviada para o email',
  naoRecuperouUsuario: 'Não foi possível recuperar os dados do usuário!',
  formatoInvalido: 'O formato do campo é inválido!',
  nomeLetras: 'O nome deve conter no mínimo 3 letras!',
  nomeMaxLetras: 'O nome deve conter no máximo 50 letras!',
  campoObrigatorio: 'Este campo é obrigatório!',
  emailFormato: 'Formato de e-mail inválido.',
  emailMaxLetras: 'O campo e-mail deve conter no máximo 80 letras!',
  especifiqueUsuario: 'Especifique o tipo de usuário',
  senhaLetras: 'A senha deve conter no mínimo 8 caracteres.',
  senhaMaxLetras: 'A senha deve conter no máximo 25 caracteres.',
  senhaDiferentes: 'As senhas não são iguais.',
  limpar: 'Limpar',
  ativo: 'Ativo',
  desativado: 'Desativado',
  naoDigiteUnidadeMedida: 'Não digite a unidade de medida',
  avisoViaEmail: 'Receber um aviso via e-mail?',
  emailsDestinos: 'E-mails de destinos',
  estoque: 'Estoque',
  estoqueDisponivel: 'Estoque disponível',
  estoqueLimite: 'Estoque acabando ou esgotado',
  receberAvisoEstoqueText: 'Indicar na tabela quando o estoque estiver em *',
  estoqueMinimoAtualizadoSucesso: 'O estoque minímo foi atualizado com sucesso.',
  minimoEstoqueDesejado: 'Estoque mínimo desejado',
  naoDefinido: 'Não definido',
  legendaSemConfiguracaoEstoqueMinimo: 'Configuração não definida',
  legendaEmailDesativadoErroEstoqueMinimo: 'Estoque abaixo do limite e e-mail desativado',
  legendaEmailDesativadoEstoqueMinimo: 'Estoque disponível e e-mail desativado',
  legendaEstoqueMinimoAlerta: 'Estoque abaixo do limite',
  legendaEstoqueMinimoErro: 'Estoque esgotado',
  legendaEstoqueMinimoIdeal: 'Estoque disponível',
  formatoCampoEmailInvalido: 'Formato de email inválido, por favor verifique',
  requiredFieldValorEstoqueMinimo: 'Campo de estoque minimo está vazio, por favor preencha',
  requiredFieldTypeErrorNumber: 'Campo deve ser preenchido com numeros',
  requiredFieldEmail: 'Campo e-mail vazio, por favor preencha-o',
  historicoCompleto: 'Modo histórico completo',
  descricaoHistorico:
    "<p>O modelo histórico traz em cada e-mail de atualização <span style='text-decoration: underline'>todas as etapas percorridas</span> pelo processo com datas e contexto. Você pode ativar o botão e receber neste formato.</p> <p>Caso deixe desabilitado, o conteúdo do e-mail será apenas a última atualização.</p>",
  // AG-GRID
  equals: 'Igual',
  notEqual: 'Diferente de',
  blank: 'Vazio',
  notBlank: 'Não vazio',
  contains: 'Contém',
  notContains: 'Não contém',
  startsWith: 'Começa com',
  endsWith: 'Termina com',
  filter: 'filtro',
  andCondition: 'E',
  orCondition: 'OU',
  busqueCNPJ: 'Busque as empresas pelo nome ou CNPJ.',
  removerEmpresas: 'Remover empresas',
  aplicar: 'Aplicar',
  cliqueCardDetalhes: 'Clique no card para mais detalhes',
  fechamento: 'Fechamento',
  pending: 'Pendente',
  in_transit: 'Em trânsito',
  occurrence_treatment: 'Tratando ocorrência',
  done: 'Entregue',
  motorista: 'Motorista',
  placa: 'Placa',
  valorNF: 'Valor NF',
  pesoRealNF: 'Peso real NF',
  tituloEstoqueMinimo: 'Estoque mínimo',
  buscaAvancada: 'Busca avançada',
  codProcesso: 'Cód. Processo',
  paisOrigem: 'País origem',
  paisDestino: 'País destino',
  placaRodoviario: 'Placa (Rodoviário)',
  dataEntregaContainer: 'Data de entrega container',
  removerSelecionados: 'Remover selecionados',
  marcarDesmarcarTodos: 'Marcar / desmarcar todos',
  // LI
  digitarDI: 'Digitar DI',
  gestaoLicencasImportacao: 'Licenças de Importação',
  gestaoLI: 'Gestão de L.I.',
  licencaImportacao: 'Licença de Importação',
  visualizeLI:
    'Acompanhe as licenças necessárias para a importação, visando a regulamentação do comércio internacional e proteção da economia nacional.',
  dataSituacao: 'Data Situação',
  li: 'LI',
  dataReg: 'Data Reg.',
  validadeSituacao: 'Validade Situação',
  dataProtocolo: 'Data Protocolo',
  anuencia: 'Anuência',
  paraAnalise: 'Para análise',
  emExigencia: 'Em exigência',
  deferida: 'Deferida',
  encaminhar: 'Encaminhar',
  encaminharProcessoEmail: 'Encaminhar processo por email',
  verMais: 'Ver mais',
  verMenos: 'Ver menos',
  dataTransbordo: 'Transbordo',
  dataTransbordo2: 'Segundo transbordo',
  sequencia: 'Sequência',
  ultimoAcesso: 'Último acesso',
  cliqueAdicionarProduto: 'Clique para adicionar novo produto',
  house: 'BL House',
  master: 'BL Master',
  tipoContainer: 'Tipo de container',
  armador: 'Armador',
  lacre: 'Lacre',
  dataChegadaContainer: 'Chegada do Container',
  vencimentoFreetime: 'Vencimento Freetime',
  situacaoEvento: 'Situação do Evento',
  containerDevolvido: 'Contêiner Devolvido',
  dataEvento: 'Data do Evento',
  situacaoEventoArmador: 'Situação do Evento pelo Armador',
  nomeNavio: 'Nome do Navio',
  localEvento: 'Local do Evento',
  identificacaoViagem: 'Identificação da Viagem',
  dataViagem: 'Data da Viagem',
  Modalidade: "Modalidade",
  Porcentagem: "Porcentagem",
  Valor: "Valor",
  Invoice: 'Invoice',
  Abertos: "Abertos",
  Encerrados: "Encerrados",
  'Tipo vencimento': 'Tipo de Vencimento',
  statusDoProcesso: 'Status do processo',
  reenviarEmailProcesso: 'Reenviar e-mail do processo',
  erroAoEnviarEmail: 'Ocorreu um erro ao enviar o e-mail',
  aperteEnterParaCadaEmail: 'Aperte a tecla enter para cada endereço de e-mail digitado',
  tipoDeImportacao: 'Tipo de importação',
  cliqueParaBaixar: 'Clique para baixar',
  extratoLI: 'Extrato da L.I',
  // ged
  documentoBaixadoSucesso: 'Documento baixado com sucesso',
  erroBaixarDocumento: 'Ocorreu um erro ao baixar o documento',
  erroVisualizarDocumento: 'Ocorreu um erro ao visualizar o documento',
  //Produtos Processos
  'PET - RESINA': 'PET - RESINA',
  'PVC - RESINA': 'PVC - RESINA',
  'PROPRIO DIVERSOS': 'PROPRIO DIVERSOS',
  'SUPLEMENTOS': 'SUPLEMENTOS',
  // gestao containers
  containersNaoEncontrados: 'Containers não encontrados para este tipo de filtro',
  // GRÁFICOS
  indicadores: 'Indicadores',
  licencasDeferidas: 'Licenças deferidas',
  comExigencia: 'Com exigência',
  semExigencia: 'Sem exigência',
  tempoAberturaDeferimento: 'Tempo de abertura até o deferimento (dias)',
  expectativaChegada: 'Expectativa de chegada',
  codCalculo: 'Código cálculo receita/custo',
  estadoCalculo: 'Estado cálculo receita/custo',
  dataInicio: 'Data início',
  dataFim: 'Data fim',
  valorServico: 'Valor do serviço',
  valorCalculado: 'Valor calculado',
  ordemCompra: 'Ordem de compra',
  aVista: 'À vista',
  aPrazo: 'À prazo',
  termosPagamento: 'Termos do pagamento',
  portoOrigem: 'Porto origem',
  portoDestino: 'Porto destino',
  enderecoExportador: 'Endereço exportador',
  selecionarCNPJ: 'Selecione e vincule os CNPJs ao usuário',
  vincular: 'Vincular CNPJs selecionados',
  Vincular: 'Vincular',
  // TabName
  'Login': 'Login',
  'Home': 'Home',
  'AberturaProcesso': 'Abertura de Processo',
  'ProcessosKanban': 'Follow-Up',
  'GestaoLI': 'Gestão de LI',
  'ListagemProcesso': 'Listagem de Processos',
  'TransitTime': 'Transit Time',
  'Estoque': 'Estoque',
  'Financeiro': 'Financeiro',
  'AgendamentoRelatorios': 'Relatórios',
  'Ged': 'Gerenciamento Eletrônico de Documentos',
  'Mensageiro': 'Mensageiro',
  'Tarefas': 'Gestão de Tarefas',
  'ListarUsuarios': 'Usuários',
  'Produtos': 'Produtos',
  'Dashboard': 'Dashboard',
  'Empresas': 'Empresas',
  'Manutencao': 'Manutenção',
  'RecuperarSenha': 'Esqueceu sua senha',
  'processosParceiros': 'Parceiros',
  'processosComissao': ' Parceiros',
  bugs: 'Bugs: ',
  melhorias: 'Melhorias: ',
  manutencao: 'Manutenção: ',
  novidades: 'Novidades: ',
  patchNotes: 'Notas de Atualização',
  assistente: 'Assistente',
  assistente1: 'Assistente 1',
  assistente2: 'Assistente 2',
  assistentes: 'Assistentes',
  introPatchNotes1: 'Essas são apenas algumas das melhorias e funcionalidades introduzidas em cada versão do trinity. Estamos sempre empenhados em aprimorar a plataforma e oferecer a você a melhor experiência possível.',
  introPatchNotes2: 'Estaremos compartilhando informações sobre futuras versões e recursos emocionantes que estão por vir.',
  manutencoes: 'Manutenções',
  aguardandoAtualizacao: 'Aguardando atualização',
  copiarLinkProcesso: 'Copiar link do processo',
  estrategico: 'Estratégico',
  chat: 'Chat',
  entendi: 'Entendi',
  aindaNaoEmbarcado: 'Ainda não foi embarcado',
  seuProcessoAindaNaoEmbarcado: 'Seu processo ainda não foi embarcado.',
  fiqueOlho: 'Fique de olho nos próximos dias.',
  ops: 'Oops',
  processoNaoEncontrado: 'Este processo não foi encontrado',
  naoRegistrado: 'Pode ser que seu navio esteja numa área sem radar ou que o navio não tenha sido registrado.',
  transporteAereo: 'Transporte aéreo',
  seuProcessoAereo: 'Seu processo está na modalidade de transporte aéreo.',
  naoApareceMapa: 'No momento esta modalidade não aparece no mapa.',
  transitoConcluido: 'Trânsito concluído',
  processoNaoTransito: 'Seu processo não está mais em trânsito.',
  cliqueDetalhesProcesso: 'Clique para conferir os detalhes deste processo.',
  verDetalhes: 'Ver detalhes',
  // CRC
  crcMenu: 'Custo Armaz...',
  crc: 'Custo do Armazém',
  codigoCRC: 'Código Cálculo Receita/Custo',
  estadoCRC: 'Estado Cálculo Receita/Custo',
  descricaoServico: 'Descrição serviço',
  quantidadeServico: 'Quantidade serviço',
  editarEmpresa: 'Editar empresa',
  // Cadastros
  cadastroBasico: 'Cadastros básicos',
  fornecedorProdutor: 'Fornecedor / Produtor',
  siglaSimbolo: 'Sigla/Simbolo',
  Cadastro: 'Cadastro',
  salvoComSucesso: 'salvo com sucesso',
  deletadoComSucesso: 'foi deletado com sucesso',
  sigla: 'Sigla',
  tipo: 'Tipo',
  alta: 'Alta',
  media: 'Média',
  baixa: 'Baixa',
  prioridade: 'Prioridade',
  // DNA Empresas
  dna: 'DNA',
  sequencial: 'Sequencial',
  questionario: 'Questionário',
  questionarios: 'Questionários',
  perguntas: 'Perguntas',
  respostas: 'Respostas',
  perguntasAndRespostas: 'Perguntas e Respostas',
  responsavelComex: 'Responsável comex',
  assistenteComex: 'Assistente comex',
  responsavelExecutivo: 'Responsável executivo',
  //
  totalProcessosDescricao: 'Processos em andamento por status',
  totalProcessosFechadosAno: 'Processos concluídos por ano',
  statusProcessosDescricao: 'Em relação ao previsao de embarque original',
  canalParametrizacaoDescricao: 'Em relação aos processos em andamento',
  topProdutosDescricao: 'Em relação a quantidade de notas',
  acertoNumerarioDescricao: 'Em relação entre valor Previsto vs  valor Realizado',
  //
  tempoLiberacaoFechamentoDescricao: 'Em relação a data da presenca da carga',
  placeholderFornecedorProdutorInputNome: 'Empresa exemplo ltda.',
  placeholderFornecedorProdutorInputCNPJ: '00.000.000/0001-00',
  placeholderMoedaInputSiglaSimbolo: 'USD',
  placeholderMoedaInputDescricao: 'Dollar Americano',
  placeholderUnidadeMedidaInputSiglaSimbolo: 'KG',
  placeholderUnidadeMedidaInputDescricao: 'Quilogramas',
  recuperarRascunho: 'Retomar rascunho',
  previsao: 'Previsão', mensagemAddInformacaoCadastroBasico: 'Se deseja adicionar um novo item, por favor, entre em contato com um administrador.',
  mensagemCampoDescricaoCadastroBasico: 'O campo descrição deve conter no mínimo 5 caracteres.',
  mensagemCampoSiglaMoeda: 'O campo sigla deve conter no mínimo 3 caracteres.',
  mensagemCampoSiglaUnidadeMedida: 'O campo sigla deve conter no mínimo 2 caracteres.',
  mensagemCampoNomeFornecedorProdutor: 'O campo nome deve conter no mínimo 5 caracteres.',
  mensagemCampoCNPJFornecedorProdutor: 'O campo CNPJ não precisa ser formatado; apenas os números são suficientes.',
  mensagemCampoCNPJLenghtFornecedorProdutor: 'O campo CNPJ deve conter 14 caracteres.',
  cadastrosBasicos: 'Cadastro básicos',
  // Simulação
  Simulacao: 'Simulação',
  simulacao: 'Simulação',
  classificacao: 'Classificação',
  filial: 'Filial/Benefícios',
  solicitadoEm: 'Solicitado em',
  recuperarSenha: 'Recuperar senha',
  nenhumaEmpresaColuna: 'Nenhuma empresa nessa coluna',
  nunhumProcessoEncontrado: 'Nenhum processo novo foi encontrado',
  abrirVisualizarAndamentoFollowup: 'Você pode abrir um novo processo ou visualizar o que está em andamento no Follow-Up',
  tooltipdataLiberacaoSiscarga: 'Data da liberação do B/L (retirada da retenção)',
  tooltipDataLiberacaoMapa: 'Data em que o ministério da agricultura efetua a liberação das embalagens de madeira da mercadoria',
  tooltipdataPresencaCarga: 'Data em que o recinto aduaneiro informa que o container está no terminal',
  LI: 'LI',
  II: 'II',
  IPI: 'IPI',
  PIS: 'PIS',
  COFINS: 'COFINS',
  'COFINS CUSTO': 'COFINS CUSTO',
  ICMS: 'ICMS',
  'PIS SAIDA': 'PIS SAIDA',
  'COFINS SAIDA': 'COFINS SAIDA',
  'MARKUP': 'MARKUP',
  'DESCONTO': 'DESCONTO',
  taxaTrust: 'Taxa Trust',
  'TAXA TRUST': 'Taxa Trust',
  comissoes: 'Comissões',
  parceiros: 'Importar Faz Crescer',
  DashboardContainers: "Dashboard containers",
  min: "Mínimo",
  max: "Máximo",
  avg: "Média",
  median: "Mediana",
  count: "Contagem",
  escolhaAbaixo: 'Escolha abaixo',
  //Mercado Hoje
  mercadoHojeTitulo: 'Mercado hoje',
  mercadoHoje: 'Mercado hoje',
  precoMedio: 'Preço médio',
  pesoLiquido: 'Peso líquido',
  pesoBruto: 'Peso bruto',
  referenciaProcesso: 'Referência do processo',
  valorComissao: 'Valor da comissão',
  parcelasPagamento: 'Parcelas de pagamento',
  dataComissao: 'Data da comissão',
  icms: 'ICMS',
  valorIcms: 'Valor ICMS',
  tipoImportacao: 'Tipo de importação',
  ocultar: 'Ocultar',
  exibir: 'Exibir',
  'Cliente': 'Cliente',
  nomeArquivo: ' Nome arquivo',
  novoProcesso: 'Novo processo',
  referenciaPO: 'Referência (PO ou invoice)',
  expandirDiminuir: 'Expandir / Diminuir',
  despesasImportacaoDetalhamento: 'Despesas Importação Detalhamento',
  downloadPDF: 'Baixar PDF',
  recarregar: 'Recarregar',
  // Pré faturamento
  preFaturamento: 'Pré-faturamento',
  carregamentoProgramado: 'Carregamento programado',
  horario: 'Horário',
  liberacaoMapa: 'Liberação Mapa',
  liberacaoSiscarga: 'Liberação Siscarga',
  transportador: 'Transportador',
  taxaCambialDI: 'Taxa cambial D.I',
  beneficioFiscal: 'Benefício fiscal',
  descricaoItem: 'Descrição Item',
  despachante: 'Despachante',
  armazemDesembaraco: 'Armazém Desembaraço',
  recintoEntrada: 'Recinto de entrada',
  codigoInvoice: 'Código Invoice',
  quantidadeContainers: 'Quantidade de containers',
  quantidadeLIs: 'Quantidade de LI\'s',
  diasLivres: 'Dias livres',
  CE: 'C.E',
  desembaraco: 'Desembaraço',
  saldoConta: 'Saldo conta',
  custosAlocadosOutroProcesso: 'Custos alocados de outro processo',
  THC: 'THC',
  observacoesProcesso: 'Observações do processo',
  codigo: 'Código',
  emissao: 'Emissão',
  numeroDocumento: 'N° Doc',
  adiantamento: 'Adiantamento',
  descricaoPessoa: 'Descrição de pessoa',
  uf: 'UF',
  numAdicao: 'N° Adicao',
  numItem: 'N° Item',
  codigoExportacao: 'Código Exportação',
  contaProjeto: 'Conta de projeto',
  valorMoedaNacional: 'Valor moeda nacional',
  formaRateio: 'Forma rateio',
  encargo: 'Encargo',
  ONU: 'ONU',
  descricaoCliente: 'Descrição cliente',
  embalagem: 'Embalagem',
  nomePasta: 'Nome da pasta',
  informacoesProcesso: 'Informações do processo',
  financeiroPagar: 'Financeiro a pagar',
  comparativoProdutosDIs: 'Comparativo produto(s) D.I.',
  comparativoProdutoInvoice: 'Comparativo produto Invoice',
  custosEmissaoNF: 'Custos para emissão da NF',
  produtosProcesso: 'Produtos do processo',
  documentosGED: 'Documentos GED',
  comparativosProdutoDIs: 'Comparativo produto(s) D.I',
  mensagemRascunhos: 'Retome as informações de solicitações anteriores que não foram finalizadas.',
  editarSolicitacaoProcesso: 'Editar Solicitação de Processo',
  prazoPagamento: 'Prazo de pagamento',
  downloadExcel: 'Download tabela em Excel',
  substituta: 'Substituta',
  limparFiltros: 'Limpar filtros',
  valoresInvoice: 'Total dos produtos da invoice',
  PrevisaoArmazem: 'Previsão Armazém',
  DiasRestantesChegada: 'Dias restantes para chegada',
  dataMovimento: 'Data de movimento',
  segmentoProduto: 'Segmento do produto',
  valorProcesso: 'Valor total processo',
  dataChegouPorto: 'Carga já chegou ao porto de destino',
  previsaoDemandaDomestica: 'Previsão demanda doméstica',
  PrevisaoDemandaDomestica: 'Previsão demanda doméstica',
  demandaDomestica: 'Demanda doméstica',
  processosPendentes: 'Processos pendentes',
  bl: 'BL',
  enviosEmail: 'Envios no e-mail',
  esteProcessoPossui: 'Este processo possui',
  um: 'Um',
  acabouAberto: 'acabou de ser aberto',
  tooltipdataAbertura: 'Início formal do processo de importação com a Trading, começando os trâmites legais e administrativos.',
  tooltipdataEmbarque: 'Dia em que as mercadorias são efetivamente carregadas no meio de transporte para serem enviadas do país de origem para o país de destino.',
  tooltipnumeroRegistroDI: 'A Declaração de Importação registra detalhes como dados do fabricante, importador, classificação fiscal e valores de impostos. Trata-se de um pré-requisito para o despacho aduaneiro.',
  tooltipdataVistoriaMapa: 'O Ministério da Agricultura, Pecuária e Abastecimento é responsável pela fiscalização do trânsito internacional das embalagens, impedindo o ingresso de pragas.',
  tooltipeta: 'Data estimada da chegada do navio no porto.',
  tooltipetd: 'Data estimada da saída do navio no porto.',
  tooltipdataRecebimentoOriginais: 'São os documentos instrutivos do processo, exemplo: Invoice, packing list e BL.',
  tooltipdataTransbordo: 'As mercadorias terão que mudar de navio durante a viagem, pela rota já traçada.',
  tooltipsdataTransbordo2: 'As mercadorias terão que mudar de navio pela segunda vez durante a viagem, pela rota já traçada',
  tooltipdataLiberacaoMapa: 'Data em que o Ministério da Agricultura, Pecuária e Abastecimento autoriza a liberação das mercadorias, mediante fiscalização documental ou física,',
  tooltipdataChegada: 'Momento em que as mercadorias importadas alcançam o porto de destino, marcando o início dos procedimentos aduaneiros e logísticos.',
  tooltipdataDesembaracoDI: 'Desembaraço aduaneiro da Declaração de Importação. Inclui a análise e aprovação pela alfândega dos documentos da importação, permitindo a liberação das mercadorias.',
  tooltipdataDesembaracoDi: 'Desembaraço aduaneiro da Declaração de Importação. Inclui a análise e aprovação pela alfândega dos documentos da importação, permitindo a liberação das mercadorias.',
  tooltipconhecimentoEmbarque: 'Também conhecido como Bill of Lading (B/L), serve como um recibo para as mercadorias embarcadas e como um documento de título da posse das mercadorias durante o transporte.',
  tooltipemissãoNotaEntrada: 'Geração de documento fiscal pela empresa importadora que é utilizado para formalizar a entrada dos produtos adquiridos no exterior.',
  tooltipcarregamento: 'Data que está previsto o carregamento do processo ou este já foi realizado.',
  tooltipdataExecucaoCarregamento: 'Data que o container foi retirado do Porto.',
  tooltipcarregamentoAgendado: 'Agendamento do momento em que as mercadorias serão carregadas para o veículo e retiradas do Porto. Não sei se tem na Trinity essa data.',
  tooltipdataFechamentoOperacional: 'Conclusão das operações logísticas e administrativas relacionadas à importação.',
  tooltipdataFaturamento: 'Emissão da Nota fiscal eletrônica, detalhando descrição das mercadorias, quantidades, preços, termos de pagamento, entre outros.',
  tooltipdataEnvioFaturamento: 'Data que a NF-e foi enviada via sistema',
  ForgotPassword: 'Esqueci minha senha',
  consultarProcessos: 'Consultar processos',
  realizarCotacao: 'Realizar uma cotação',
  documentosGerais: 'Documentos gerais',
  fretes: 'Fretes',
  performance: 'Performance',
  analiseFrete: 'Análise de frete',
  acuraciaEstoque: 'Acurácia do estoque',
  eficaciaGeral: 'Eficácia geral',
  basicos: 'Básicos',
  portuariaVigentes: 'Portuária vigentes',
  tarefasComex: 'Tarefas do COMEX',
  interno: 'Interno',
  armazenamento: 'Armazenamento',
  gerais: 'Gerais',
  sugerirTrasnportadora: 'Sugerir transportadora',
  responsavelFrete: 'Responsável pelo Frete',
  agenciamentoInternacional: 'Agenciamento Internacional',
  LIs: 'LI\'s ',
  acuraciaArmazem: 'Eficácia Geral das Operações de Armazenagem (OOE)',
  operacional: 'operacional',
  deProcesso: 'de Processo',
  esteEMais: 'Este e mais',
  processosForamEncerrados: 'processos foram encerrados',
  esteProcessoEncerrado: 'Este processo foi encerrado',
  // Unidade de negócio
  filtrarVisualizacaoUnidadeNegocio: 'Filtrar visualização por unidade de negócio',
  selecioneOqueDesejaExibir: 'Selecione o que deseja visualizar no sistema',
  nenhumaUnidadeNegocio: 'Nenhuma unidade de negócio nesta coluna',
  todasAsUnidades: 'Todas as unidades',
  unidadesDeNegocio: 'Unidades de Negócio',
  unidades: 'unidades',
  conteudo: 'Conteúdo',
  tempoAteAgora: 'Tempo decorrido até agora.',
  nenhumNavioHorizonte: 'Nenhum navio no horizonte ainda.',
  mensagemAberturaProcessoQuandoVazio: 'Clique no botão acima para lançar um novo processo de importação e trazer vida a este vasto oceano azul!',
  containersPorMes: 'Quantidade de containers importados por mês',
  containersPorPorto: 'Quantidade de containers importados por porto',
  mediaFreeTime: 'Médias de dias freetime por armador',
  tipoArquivo: 'Tipo de arquivo',
  extensao: 'Extensão',
  dataCadastro: 'Data de Cadastro',
  navegueAguasInformacao: 'Navegue pelas águas da informação com facilidade!',
  programeEmails: 'Programe seus e-mails, escolhendo os dias que melhor se encaixam na sua maré de tarefas, e receba suas importações atualizadas.',
  semPerderRumo: 'Assim, você estará sempre a par das novidades, sem perder o rumo das suas mercadorias!',
  doc: 'Doc',
  minuta: 'Minuta',
  emissaoCTe: 'Emissão CTe',
  nf: 'Nota Fiscal',
  qtdeNF: 'Qtde Nota Fiscal',
  volumes: 'Volumes',
  pesoTaxado: 'Peso Taxado',
  valorFrete: 'Valor Frete',
  valorKG: 'Valor KG',
  freteNF: 'Frete Nota Fiscal (%)',
  pesoTotal: 'Peso Total',
  valorMedioKG: 'Valor Médio/KG',
  olaNavegador: 'Olá, navegador das estradas de dados!',
  nossoTransporteNaoComecou: 'Parece que nossa jornada de transporte de informações ainda não começou.',
  prontosCarregar: 'Estamos todos engajados e prontos para carregar, mas o depósito de dados ainda está vazio.',
  assimTiverInfo: 'Assim que obtivermos novas informações, atualizaremos aqui. Um abraço!',
  fretesPerformance: 'Performance de Entrega',
  performanceEntrega: 'Performance de Entrega',
  fretesFinalizados: 'Fretes finalizados',
  pendentes: 'Pendentes',
  finalizadosPrazo: 'Finalizados no prazo',
  finalizadosForaPrazo: 'Finalizados fora prazo',
  dentroPrazo: 'Dentro do prazo',
  foraPrazo: 'Fora do prazo',
  finalizacao: 'Finalização',
  statusEntrega: 'Status Entrega',
  mestreEntregas: 'Olá, mestre das entregas!',
  recemLavado: 'Sua tela de Performance está tão limpa quanto um caminhão recém-lavado.',
  baixarArquivo: 'Baixar arquivo',
  diarioNovo: 'Esta tela está tão vazia quanto um diário de bordo novo.',
  esperandoAnsiosamente: 'Esperando ansiosamente pelo próximo grande carregamento.',
  naoSePreocupe: 'Não se preocupe, assim que obtivermos novas informações, atualizaremos aqui.',
  ocultarModalSelectClient: 'Ocultados',
  exibirModalSelectClient: 'Exibindo',
  estatisticas: 'Estatísticas',
  fcl: 'FCL',
  lcl: 'LCL',
  olaPiloto: 'Olá, piloto da logística!',
  estradaDeserta: 'Sua tela de análise está tão tranquila quanto uma estrada deserta na madrugada.',
  redefinirSenha: 'Redefinir senha',
  novaSenha: 'Nova senha',
  confirmarNovaSenha: 'Confirmar nova senha',
  sugestoesSenhaForte: 'Sugestões para uma senha forte',
  cidade: 'Cidade',
  estado: 'Estado',
  finalizado: 'Finalizado',
  armazemEmptyState: 'Este espaço vazio é o convite para carregar novas cargas de produtos de todos os cantos do mundo. Quando suas mercadorias chegarem, configure seus alertas para estar sempre abastecido.',
  nenhumCusto: 'Nenhum custo registrado aqui',
  houverArmazenamento: 'Se houver algum armazenamento, informaremos todos os detalhes.',
  dataEntrega: 'Data de entrega',
  cargaImo: 'Carga IMO',
  desvincularCNPJ: 'Desvincular este CNPJ',
  desvincularTodos: 'Desvincular todos',
  nenhumDocumentoEncontrado: 'Nenhum documento encontrado.',
  nenhumDocumentoVinculado: 'Nenhum CNPJ vinculado',
  tooltipPresencaCarga: 'Data em que a alfândega informa que o contêiner está no terminal',
  marca: 'Marca',
  estoqueAtual: 'Estoque atual',
  quantidadeComprada: 'Quantidade Comprada',
  dataInvoice: 'Data Invoice',
  valorInvoice: 'Valor Invoice',
  previsaoCambio: 'Previsão Câmbio',
  distribuicao: 'Distribuição',
  tooltipfreetime: '',
  tooltipdataRegistroDi: '',
  tooltipdataEntregaContainer: '',
  tooltipdataTransbordo2: '',
  tooltipundefined: '',
  repliques: 'Repliques',
  chaveAcesso: 'Chave de Acesso',
  serie: 'Série',
  pagador: 'Pagador',
  CFOP: 'CFOP',
  tipoCST: 'Tipo CST',
  baseICMS: 'Base ICMS',
  prcICMS: 'PRC ICMS',
  totalNota: 'Total Nota',
  vinculeDocumentos: 'Vincule CNPJs para ter acesso aos rastreios e detalhes de processos.',
  tamanhoArquivo: 'O tamanho dos arquivos está acima do permitido (100mb). Por favor, verifique.',
  tamanhoArquivoAviso: 'Alguns arquivos não foram carregados, seu tamanho está acima do permitido (100mb). Por favor, verifique.',
  duplicar: 'Duplicar',
  mediaDuracaoDias: 'Média de duração (dias) por etapa',
  pedidosCaminho: 'Pedidos a caminho',
  repliquesTitle: 'Repliques CTes',
  redefinirDatas: 'Redefinir Datas',
  posicaopallet: 'Posição do pallet',
  dataentrada: 'Data entrada',
  ola: 'Olá',
  produtosMaisImportados: 'Produtos mais importados',
  tempoMedioCarregamento: 'Tempo médio (dias) da presença de carga até o carregamento',
  tempoMedioProduto: 'Tempo médio (dias) para o carregamento por produto',
  itensSelecionado: 'itens selecionados',
  receberEmail: 'Receber no e-mail',
  dataDesembaracoDi: 'Data de desembaraço D.I',
  FILIAL_ESL: 'Filial ESL',
  FILIAL_CNX: 'Filial CNX',
  CTE_ESL: 'CTE ESL',
  CTE_CNX: 'CTE CNX',
  STATUS_ESL: 'Status ESL',
  STATUS_CNX: 'Status CNX',
  CHAVE_ACESSO: 'Chave de Acesso',
  DOC_COD: 'Codigo de Documento CNX',
  SERIE_ELS: 'Serie ESL',
  SERIE_CNX: 'Serie CNX',
  EMISSAO_ESL: 'Emissão ESL',
  EMISSAO_CNX: 'Emissão CNX',
  PAGADOR_ESL: 'Pagador ESL',
  PAGADOR_CNX: 'Pagador CNX',
  CNPJ_ESL: 'CNPJ ESL',
  CNPJ_CNX: 'CNPJ CNX',
  CFOP_ESL: 'CFOP ESL',
  CFOP_CNX: 'CFOP CNX',
  BASEICMS_ESL: 'Base ICMS ESL',
  BASEICMS_CNX: 'Base ICMS CNX',
  PRCICMS_ESL: 'PRC ICMS ESL',
  PRCICMS_CNX: 'PRC ICMS CNX',
  ICMS_ESL: 'ICMS ESL',
  ICMS_CNX: 'ICMS CNX',
  TOTALNOTA_ESL: 'Total Nota ESL',
  TOTALNOTA_CNX: 'Total Nota CNX',
  aviao: 'Avião',
  eslFilial: 'Filial ESL',
  conexosFilial: 'Filial CNX',
  eslCTE: 'CTE ESL',
  conexosCTE: 'CTE CNX',
  eslStatus: 'Status ESL',
  conexosStatus: 'Status CNX',
  codigoDocumentoConexos: 'Código Documento Conexos',
  eslSerie: 'Serie ESL',
  conexosSerie: 'Serie CNX',
  eslEmissao: 'Emissão ESL',
  conexosEmissao: 'Emissão CNX',
  eslPagador: 'Pagador ESL',
  conexosPagador: 'Pagador CNX',
  eslCNPJ: 'CNPJ ESL',
  conexosCNPJ: 'CNPJ CNX',
  eslCFOP: 'CFOP ESL',
  conexosCFOP: 'CFOP CNX',
  eslBaseICMS: 'Base ICMS ESL',
  conexosBaseICMS: 'Base ICMS CNX',
  eslPRCICMS: 'PRC ICMS ESL',
  conexosPRCICMS: 'PRC ICMS CNX',
  eslICMS: 'ICMS ESL',
  conexosICMS: 'ICMS CNX',
  eslTotalNota: 'Total Nota ESL',
  conexosTotalNota: 'Total Nota CNX',
  rastreioOriginais: 'Rastreio de originais',
  rastreioDocumentosOriginais: 'Rastreio de documentos originais',
  local: 'Local',
  iniciarJornada: 'Para iniciar a jornada de rastreamento, por favor, insira o código de rastreio no campo de navegação acima.',
  coordenadasCorretas: 'Com as coordenadas corretas, vamos zarpar rumo à localização precisa do seu documento valioso!',
  armazenado: 'Armazenado',
  'Valor Total Invoice': 'Valor Total Invoice',
  'Free Time': 'Free Time',
  'Porto Destino': 'Porto Destino',
  'Mapa': 'Mapa',
  'Presença de Carga': 'Presença de Carga',
  Siscarga: 'Siscarga',
  baixarTodosDocumentos: 'Baixar todos os documentos',
  disponivel: 'Disponível',
  abaixoLimite: 'Abaixo do limite',
  esgotado: 'Esgotado',
  inventarioTitle: 'Histórico e precisão do Inventário',
  inventarioToolTip: 'Contagem do estoque para conhecimento do que falta, do que está em excesso e o que está vencido.',
  quantidadeEstoque: 'Quantidade Estoque',
  quantidadeInventario: 'Quantidade Inventariada',
  historicoProdutosInventario: 'Histórico de produtos no inventário',
  categoriasProdutos: 'categorias de produtos',
  inventariosRealizados: 'Inventários realizados',
  precisaoInventario: 'Precisão de Inventário',
  quantidadeTotalInventario: 'Quantidade Total no Inventário',
  totalItens: 'Total de itens',
  detalhamentoProduto: 'Detalhamento por produto',
  NoticiasClientes: 'Notícias para clientes',
  noticiasInternas: 'Notícias internas para os clientes',
  criarEnvio: 'Criar Envio',
  criarEnvioEmail: 'Criar um envio de e-mail',
  titulo: 'Titulo',
  enviarPara: 'Enviar para',
  dataEnvio: 'Data do envio',
  tituloEmail: 'Título do e-mail',
  digiteEmailOrSelecioneGrupo: 'Digite e-mails ou selecione os grupos',
  corpoTexto: 'Corpo de texto',
  noticiaCriada: 'Noticia criada',
  noticiaApagada: 'Noticia apagada',
  editarEnvioEmail: 'Editar um envio de e-amil',
  noticiaAtualizada: 'Noticia atualizada',
  redirecionar: 'Redirecionar',
  dataEntrada: 'Data de entrada',
  posicaoPallet: 'Posição do Pallet',
  repliquesNFe: 'Repliques NF-e',
  especieDocumento: 'Especie Documento',
  codigoEmpresa: 'Código Empresa',
  descricaoEmpresa: 'Descrição Empresa',
  retornoSefaz: 'Retorno Sefaz',
  codigoBeneficio: 'Código Beneficio',
  frete: 'Frete',
  totalProdutos: 'Total produtos',
  totalDocumentos: 'Total documentos',
  historicoInventario: 'Você ainda não possui um histórico de inventário.',
  inventarioAtualizado: 'Assim que for realizado, apresentaremos todos os detalhes aqui.',
  exibirPrecisaoQuandoFeita: 'Será exibida uma precisão do inventário quando for feita a contagem dos produtos do estoque.',
  nenhumInventarioRealizado: 'Não foi realizado nenhum inventário até o momento.',
  houverInvenarioDetalhesAqui: 'Quando houver um inventário, os detalhes de produtos serão apresentados aqui.',
  selecioneInventario: 'Selecione o inventário de 1 empresa',
  controlTowerComex: 'Control Tower',
  controlTowerComexTitle: 'Control Tower Comércio Exterior',
  adquirente: 'Adquirente',
  vistoriaMapa: 'Vistoria Mapa',
  agenteCarga: 'Agente de Carga',
  desova: 'Desova',
  desovaSim: 'Desova Sim',
  operacao: 'Operação',
  originais: 'Originais',
  transporteCarregamento: 'Transporte Carregamento',
  ce: 'CE',
  atracao: 'Atração',
  necessitaLi: 'Necessita L.I',
  emissaoLi: 'Emissão L.I',
  statusLi: 'Status L.I',
  di: 'D.I.',
  canal: 'Canal',
  ric: 'RIC',
  terminalDevolucao: 'Terminal Devolução',
  recebimentoBlOriginal: 'Recebimento B/L Original',
  vencimentoFreeTime: 'Vencimento Free Time',
  demurrage: 'Demurrage',
  remocaoArmazem: 'Remoção Armazém',
  registroDi: 'Registro da D.I.',
  analista: 'Analista',
  aeroporto: 'Aeroporto',
  despesasImportacao: 'Despesas de Importação',
  modalidadeImportacao: 'Modalidade de Importação',
  valorFOBUnitarioMoeda: 'Valor Unitário FOB (Moeda)',
  valorFOBUnitarioReal: 'Valor Unitário FOB (Real)',
  valorUnitarioNegociado: 'Valor Unitário FOB Negociado',
  moedaInvoice: 'Moeda do Invoice',
  valorFOBTotalReal: 'Valor FOB Total (Real)',
  dataRegistroCanalParametrizacao: 'Data de Registro do Canal de Parametrização',
  moedaFreteIntl: 'Moeda do Frete Internacional',
  valorFreteInternacionalReal: 'Valor do Frete Internacional (Real)',
  valorSeguroInternacionalDolar: 'Valor do Seguro Internacional (Dólar)',
  valorSeguroInternacionalReal: 'Valor do Seguro Internacional (Real)',
  outrasDespesas: 'Valor de Outras Despesas',
  valorCIF: 'Valor CIF',
  aliqIIPorcentagem: 'Alíquota II (%)',
  aliqIPIPorcentagem: 'Alíquota IPI (%)',
  aliqPISPorcentagem: 'Alíquota PIS (%)',
  aliqCOFINSPorcentagem: 'Alíquota COFINS (%)',
  valorII: 'Valor II',
  valorPIS: 'Valor PIS',
  valorCOFINS: 'Valor COFINS',
  siscomex: 'Siscomex',
  valorTotalNFe: 'Valor Total da NFe',
  valorArmazenagem: 'Valor de Armazenagem',
  freteNacional: 'Frete Nacional',
  totalDespesas: 'Total de Despesas',
  valorTotalFaturado: 'Valor Total Faturado',
  valorDescComercial: 'Valor do Desconto Comercial',
  codigoDocFiscalSaida: 'Código do Documento Fiscal de Saída',
  baseCalculoIPI: 'Valor da Base de Cálculo do IPI',
  baseCalculoImpostoImportacao: 'Valor da Base de Cálculo do II',
  descricaoCurta: 'Descrição curta',
  modalidadeTransporte: 'Modalidade de transporte',
  codigoDI: 'Código D.I',
  dataAberturaProcesso: 'Data abertura processo',
  devolucaoVazio: 'Devolução do vazio',
  lavacao: 'Lavação',
  transportadora: 'Transportadora',
  orgao: 'Orgão',
  quantidadeContainer: 'Quantidade de Container',
  itensDI: 'Itens da D.I.',
  numeroDI: 'Nº D.I.',
  descricaoCompleta: 'Descrição completa',
  sairSemSalvar: 'Sair sem salvar?',
  alteracoesEmailNaoAplicadas: 'As alterações não serão aplicadas no envio de e-mails.',
  wmsFilial: 'Filial WMS',
  wmsNumeroDocumento: 'Número Documento WMS',
  conexosNumeroDocumento: 'Número Documento Conexos',
  wmsDataEmissao: 'Data Emissão WMS',
  conexosDataEmissao: 'Data Emissão CNX',
  wmsDataMovimento: 'Data Movimento WMS',
  conexosDataMovimento: 'Data Movimento CNX',
  wmsChaveAcesso: 'Chave Acesso WMS',
  conexosChaveAcesso: 'Chave Acesso CNX',
  wmsStatus: 'Status WMS',
  wmsCodigoBeneficio: 'Código Benefício WMS',
  conexosCodigoBeneficio: 'Código Benefício CNX',
  wmsICMS: 'ICMS WMS',
  wmsBaseICMS: 'Base ICMS WMS',
  wmsFrete: 'Frete WMS',
  conexosFrete: 'Frete CNX',
  wmsTotalProdutos: 'Total Produtos WMS',
  conexosTotalProdutos: 'Total Produtos CNX',
  wmsTotalDocumento: 'Total Documento WMS',
  conexosTotalDocumento: 'Total Documento CNX',
  filialRepliques: 'Filial',
  nomeEmpresaInvalido: 'Nome da empresa inválido.',
  dataPrevisaoEmbarque: 'Data Previsão Embarque',
  dataPrevisaoChegada: 'Data Previsão Chegada',
  dataDesova: 'Data Desova',
  descricaoLivreProcesso: 'Observações processo',
  numerarioConexos: 'Data Geração SN Conexos',
  dataRegistroLi: 'Data Registro L.I',
  descricaoUnidadeNegocio: 'Unidade de Negócio',
  erroFetchEmpresasArmazenagem: 'Erro ao tentar obter as empresas da Armazenagem',
  dia: 'dia',
  numeroPedidoCompra: 'Número do pedido de compra',
  dataInicioProducao: 'Data do ínicio de produção',
};
